module.exports = __webpack_public_path__ + "files/77c5518ac6f5493080f73c64d0569389.png";